module.exports = __webpack_public_path__ + "img/logo.ae4608fd.png";